import { Stack, Step, styled } from '@mui/material'
import { NumberStepLabel, Stepper, tokens } from 'ComponentLibrary'

type ValuationWizardStep = {
    key: string
    label: string
}

export const ValuationWizardStepper = ({
    steps,
    currentStep,
    compact = false,
}: {
    steps: readonly ValuationWizardStep[]
    currentStep: string
    compact?: boolean
}) => {
    const currentStepIndex = steps.findIndex((step) => step.key === currentStep)
    const activeStep = currentStepIndex === -1 ? steps.length - 1 : currentStepIndex

    if (steps.length < 2) {
        return null
    }

    return (
        <StepperContainer sx={compact ? { paddingY: 0 } : undefined}>
            <Stepper activeStep={activeStep} style={{ width: '100%' }}>
                {steps.map((step, index) => (
                    <Step key={step.key}>
                        <NumberStepLabel step={index} label={step.label} />
                    </Step>
                ))}
            </Stepper>
        </StepperContainer>
    )
}

const StepperContainer = styled(Stack)(() => ({
    width: '100%',
    paddingTop: tokens.SizingSpacing300,
    paddingBottom: tokens.SizingSpacing600,
}))
